import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AvailabilityListHeaderComponent } from './components/availability-list-header/availability-list-header.component'
import { AvailabilityListControlsComponent } from './components/availability-list-controls/availability-list-controls.component'
import { SharedModule } from '@app/shared/shared.module'
import { AvailabilityListItemComponent } from './components/availability-list-item/availability-list-item.component'
import { StandardsModule } from '@app/standards-v2/standards.module'
import { MaterialModule } from '@app/material/material.module'

@NgModule({
    declarations: [
        AvailabilityListHeaderComponent,
        AvailabilityListControlsComponent,
        AvailabilityListItemComponent,
    ],
    exports: [
        AvailabilityListHeaderComponent,
        AvailabilityListControlsComponent,
        AvailabilityListItemComponent,
    ],

    imports: [CommonModule, SharedModule, StandardsModule, MaterialModule],
})
export class SharedAvailabilityListModule {}
